import Layout from '@/components/layout';
import { Ga4Event } from '@/constants/enum';
import { useGa4 } from '@/hooks/useGa4';
import userPlans from '@/hooks/userPlans';
import { gaFourSelector } from '@/redux/slice/session.slice';
import { LegacyStack } from '@shopify/polaris';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import TablePricingPlan from './components/TablePricingPlan';
import { useTranslation } from 'react-i18next';
function PricingPlan() {
  const { t } = useTranslation(['common']);
  const { newUser, userPlanShopifyPlus } = userPlans();
  const gaFour = useSelector(gaFourSelector);
  const { handleGa4 } = useGa4();

  if (!gaFour.pricingPlan) {
    handleGa4(Ga4Event.PricingPlan);
  }

  return (
    <Layout
      layoutProps={{
        title: t('pricing:pricing'),
        fullWidth: !newUser && userPlanShopifyPlus,
      }}
    >
      <LegacyStack vertical spacing="loose">
        <TablePricingPlan />
      </LegacyStack>
    </Layout>
  );
}

export default memo(PricingPlan);
